import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NationalUserComponent } from './national-user.component';
import { NationalUserListComponent } from './national-user-list/national-user-list.component';
import { NationalUserDetailComponent } from './national-user-detail/national-user-detail.component';
import { NationalUserRoutingModule } from './national-user-routing.module';
import { MaterialComponentsModule } from '../shared/material-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
//import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { MyDetailsComponent } from './my-details/my-details..component';
import { MembersSetAsActive } from './members-set-as-active/members-set-as-active.component';
import { ShowHidePasswordComponent } from 'ngx-show-hide-password';

@NgModule({
  declarations: [
    NationalUserComponent, 
    NationalUserListComponent, 
    NationalUserDetailComponent, 
    MyDetailsComponent,
    MembersSetAsActive
  ],
  imports: [
    CommonModule,
    NationalUserRoutingModule,
    MaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule  

  ]
})
export class NationalUserModule { }
